import { render, staticRenderFns } from "./member-manage.vue?vue&type=template&id=842e1f86&"
import script from "./member-manage.vue?vue&type=script&lang=ts&"
export * from "./member-manage.vue?vue&type=script&lang=ts&"
import style0 from "./member-manage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports